module.exports = __webpack_public_path__ + "static/media/10.75ecdf34.jpg";